// @flow
import Cookie from '<drivers>/cookie';
import { getFromConfig } from '~/core/state/config';

export const setupHeaders = (token: string) => {
    const apiKey = getFromConfig('homes:homeServiceApiKey');
    return {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
        Authorization: `Bearer ${token}`
    };
};

export async function renameHome(name: string, homeId: string, userId: string): Promise<*> {
    const endpoint = `${getFromConfig('homes:homeServiceUrl')}/owner/${userId}/home/${homeId}/rename`;

    const token = Cookie.get('token');
    const headers = setupHeaders(token);

    return fetch(endpoint, { headers, method: 'PUT', body: JSON.stringify({ name }) });
}



// WEBPACK FOOTER //
// ./src/core/api/homes/homes.api.js